<template>
  <div class="vx-dialog-white-mask">
    <div class="vx-loading" :class="['vx-loading-'+type]">
      <div class="vx-loading-icon"></div>
      <div class="vx-loading-txt" v-html="title"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: [String, Number],
      default: 1
    },
    title: String
  }
}

</script>
<style lang="less">
@import "../dialog.less";

</style>